module.exports = __webpack_public_path__ + "static/img/011.41b82823.jpg";